import { render, staticRenderFns } from "./ordonnance-medicale-modal.html?vue&type=template&id=2701506a&scoped=true&external"
import script from "./ordonnance-medicale-modal.js?vue&type=script&lang=js&external"
export * from "./ordonnance-medicale-modal.js?vue&type=script&lang=js&external"
import style0 from "./ordonnance-medicale-modal.scss?vue&type=style&index=0&id=2701506a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2701506a",
  null
  
)

export default component.exports